// Use $ instead of $ without replacing global $
(function ($) {

  function set_product_Title() {
    if ($('.solution-page-title-copy').length > 0) {
      setTimeout(function () {
        var solution_page_title, tab_title;
        solution_page_title = $('.solution-page-title div').text().toUpperCase();
        tab_title = $('.product-slider .slider-wrap .slider-nav .item.slick-current p').text().toUpperCase();
        $('.solution-page-title-copy').text(solution_page_title + ' ' + tab_title + ' EQUIPMENT')
      },500);
    }
  }

  $(document).ready(function () {
    set_product_Title();
  });


  $('.product-slider .slider-wrap .slider-nav .item').on('click', function () {
    set_product_Title();
  });

  $('.product-slider .slider-wrap .slide-nav .slide-prev').on('click', function () {
    set_product_Title();
  });

  $('.product-slider .slider-wrap .slide-nav .slide-next').on('click', function () {
    set_product_Title();
  });

  $('.product-slider .slider-wrap').on('swipe', function (event, slick, direction) {
    set_product_Title();
  });

  $('.product-slider .slider-outer').on('swipe', function (event, slick, direction) {
    set_product_Title();
  });

})(jQuery);
